<template>
  <div id="agreen">
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
        element-loading-text="加载中..."
        element-loading-background="rgba(0, 0, 0, 0.4)"
        v-loading.fullscreen.lock="fullscreenLoading"
      >
        <span>网站管理&nbsp;/&nbsp;协议管理</span>
        <el-button type="success" @click="handleEdit(1)">添加</el-button>
      </div>
      <div style="margin-bottom: 18px">
        <el-select
          v-model="sheng"
          placeholder="省份"
          @change="cksheng"
          style="margin-right: 16px"
        >
          <el-option
            v-for="item in shenglist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="shi"
          placeholder="城市"
          @change="ckshi"
          style="margin-right: 16px"
        >
          <el-option
            v-for="item in shilist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select v-model="xy" placeholder="协议类型">
          <el-option
            v-for="item in options"
            :key="item.type"
            :label="item.name"
            :value="item.type"
          >
          </el-option>
        </el-select>
        <el-button style="margin-left: 10px" type="primary" @click="query"
          >查询</el-button
        >
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="80" :index="1">
        </el-table-column>
        <el-table-column prop="title" label="协议标题"> </el-table-column>
        <el-table-column prop="cityName" width="200" label="所属地区">
        </el-table-column>
        <el-table-column min-width="34" fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(2, scope.row, 'agreement:update')"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row, 'agreement:delete')"
              ><i class="el-icon-delete"></i> 删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span
          >共 <i class="pagingNum">{{ total }}</i> 条</span
        >
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog
      title="协议管理/编辑"
      :visible.sync="dialogFormVisible"
      width="60%"
    >
      <p><span>*</span> 标题</p>
      <el-input v-model="title" placeholder="请输入标题"></el-input>
      <p>副标题</p>
      <el-input v-model="titles" placeholder="请输入副标题"></el-input>
      <p style="margin: 12px 0"><span>*</span> 内容</p>
      <el-input
        type="textarea"
        :rows="6"
        placeholder="请输入内容"
        v-model="content"
      >
      </el-input>
      <p style="margin: 14px 0"><span>*</span> 类型选择</p>
      <el-select v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.type"
          :label="item.name"
          :value="item.type"
        >
        </el-option>
      </el-select>
      <div>
        <p style="margin: 12px 0 14px"><span>*</span> 地区分配</p>
        <el-select
          v-model="sheng1"
          placeholder="省份"
          @change="addsheng"
          style="margin-right: 16px"
        >
          <el-option
            v-for="item in shenglist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="shi1"
          placeholder="城市"
          @change="addshi"
          style="margin-right: 16px"
        >
          <el-option
            v-for="item in shilist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button class="newbtn" @click="update">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Paging from "@/components/Paging";
export default {
  name: "agreengl",
  components: {
    Paging,
  },
  data() {
    return {
      dialogFormVisible: false,
      tableData: [],
      title: "",
      titles: "",
      content: "",
      stat: "",
      type: "",
      options: [
        { type: 1, name: "安全告知书" },
        { type: 2, name: "安全责任协议" },
      ],
      userdata: [],
      id: "",
      btn: [],
      fullscreenLoading: true,
      value: "",
      pageNum: 1,
      pageSize: 10,
      sheng: "",
      shi: "",
      shenglist: [],
      shilist: [],
      areaId: "", //筛选的id
      xy: "",
      sheng1: "",
      shi1: "",
      total: 0,
    };
  },
  created() {
    this.loadpage();
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem("region"));
    region.forEach((x) => {
      if (x.level == 0) {
        this.shenglist.push(x);
        this.sheng = x.id;
      }
    });
    if (this.userdata.level == 0) {
      this.$axios
        .post(
          `/api-r/area/getSubordinateAreaList`,
          this.$qs.stringify({ areasId: region[0].id }),
          { headers: { accessToken: this.userdata.token } }
        )
        .then((res) => {
          if (res.data.success) {
            this.$set(this, "shilist", res.data.areaListInfoList);
          }
        });
    } else {
      region.forEach((x) => {
        if (x.level == 1) {
          this.shilist.push(x);
          this.shi = x.id;
        }
      });
    }
  },
  methods: {
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.loadpage();
    },
    addsheng() {},
    addshi() {},
    loadpage() {
      let btn = JSON.parse(sessionStorage.getItem("btn"));
      this.$set(this, "btn", btn);
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        areaId: this.areaId,
        type: this.xy,
        adminAreasId: userdata.areasId,
      });
      this.$axios
        .post(`/api-r/data/getProtocolInfoList`, data, {
          headers: { accessToken: userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.$set(this, "tableData", res.data.pageInfo.list);
          this.$set(this, "total", res.data.pageInfo.total);
        });
    },
    reset() {
      this.$router.push("/refresh");
    },
    query() {
      this.pageNum = 1;
      this.fullscreenLoading = true;
      this.loadpage();
    },
    cksheng(val) {
      this.$set(this, "shi", "");
      this.areaId = val;
    },
    ckshi(val) {
      this.areaId = val;
    },
    handleEdit(stat, row, hint) {
      if (hint && this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$set(this, "stat", stat);
      this.dialogFormVisible = true;
      if (stat == 2) {
        let arr = row.cityId.split(",");
        this.$set(this, "title", row.title);
        this.$set(this, "titles", row.subtitle);
        this.$set(this, "content", row.content);
        this.$set(this, "value", row.type);
        this.$set(this, "id", row.id);
        this.$set(this, "sheng1", Number(arr[0]));
        this.$set(this, "shi1", Number(arr[1]));
      } else {
        this.$set(this, "title", "");
        this.$set(this, "titles", "");
        this.$set(this, "content", "");
        this.$set(this, "type", "");
        this.$set(this, "sheng1", "");
        this.$set(this, "shi1", "");
        this.$set(this, "value", "");
      }
    },
    handleDelete(row, hint) {
      if (hint && this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(
              `/api-r/data/deleteProtocol/${row.id}`,
              {},
              { headers: { accessToken: this.userdata.token } }
            )
            .then((res) => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.$router.replace({
                  path: "/refresh",
                  query: {
                    t: Date.now(),
                  },
                });
              }
            });
        })
        .catch(() => {});
    },
    // 更新and添加协议
    update() {
      let cityId = "";
      let arr = [];
      let arr1 = [];
      this.shilist.forEach((x) => {
        if (x.id == this.shi1) {
          arr.push(this.shenglist[0].id, this.shi1);
          arr1.push(this.shenglist[0].name, x.name);
        }
      });
      let data = {
        content: this.content,
        subtitle: this.titles,
        title: this.title,
        type: this.value,
        cityId: arr.join(","),
        cityName: arr1.join(","),
      };
      if (!data.title) {
        return this.$message.error("请填写标题");
      } else if (!data.content) {
        return this.$message.error("请填写内容");
      } else if (!data.type) {
        return this.$message.error("请选择类型");
      }
      if (this.shi1 == "") {
        return this.$message("请选择城市分配");
      }
      let url = "";
      let newdata = {};
      if (this.stat == 1) {
        url = "/api-r/data/addProtocol";
        newdata = data;
      } else {
        url = `/api-r/data/updateProtocol`;
        let stype = { id: this.id };
        Object.assign(newdata, data, stype);
      }
      this.$axios
        .post(url, this.$qs.stringify(newdata), {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          if (res.data.success == true) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.$router.replace({
              path: "/refresh",
              query: {
                t: Date.now(),
              },
            });
          } else {
            alert(res.data.msg);
          }
        });
    },
  },
};
</script>
<style>
#agreen .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* #agreen .el-input{margin: 12px 0;} */
#agreen .el-input--mini {
  margin-top: -12px;
}
/* 暂无数据样式 */
#agreen .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#agreen .el-dialog__body > P {
  margin: 12px 0 14px;
}
</style>
<style scoped lang="scss">
p > span {
  color: red;
}
.newbtn {
  background-color: #11A983;
  color: #fff;
}
.clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
